module.exports = __webpack_public_path__ + "static/media/seflie.d0f95198.jpg";